(function () {
    'use strict';

    angular
        .module('adminGovernanceProcessControllers', ['services.authenticatedUser']);
})();
